
import React, { useState, useEffect } from "react";
import axios from "axios";
import Nav from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const BoardofDirectors = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/board-of-directors`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setData(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      <Nav />
      <h2 className="mt-auto text-3xl font-bold text-center">
        Board of Directors
      </h2>
      <section className="pb-10 bg-blueGray-200 -mt-auto">
        <div className="container px-4 mx-auto">
          <div className="flex flex-wrap">
            {data.map((boa) => (
              <div className="w-full px-4 text-center md:w-4/12" key={boa.id}>
                <div className="relative flex flex-col w-full min-w-0 mb-8 break-words bg-white rounded-lg shadow-lg">
                  <div className="flex-auto px-4 py-5">
                    <div>
                      {boa.passport && boa.passport.length > 0 ? (
                        <img
                          alt=""
                          className="inline-flex items-center justify-center w-16 h-16 p-3 mb-5 text-center text-white rounded-full shadow-lg bg-lightBlue-400"
                          src={`${process.env.REACT_APP_API_URL}${boa.passport[0].url}`}
                          style={{
                            borderRadius: "25px",
                          }}
                        />
                      ) : (
                        <p>No passport image available</p>
                      )}
                    </div>
                    <div className="flex-auto px-4 py-5">
                      <h6 className="text-xl font-semibold">
                        {boa.firstName} {boa.middleName} {boa.lastName}
                      </h6>

                  
                      <Link to={`/BoardofDirectorsDetails/${boa.id}`}>Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BoardofDirectors;
